import * as React from 'react'
import { BoxHeader } from '../../../ui/box'
import CallTable from '../../call_table'
import { XhprofCallInfo } from '../../../xhprof/XhprofReportGenerator'

interface Props {
    label: string
    showContent: boolean
    panelData: { [name: string]: XhprofCallInfo }
    callAmount: string
    maximizePanel: {
        isActive: boolean
        handler: () => void
    }
    togglePanel: {
        isActive: boolean
        handler: () => void
    }
    onSelectFunction: (call: string) => void
    showPlusWhenPositive: boolean
}

interface State {}

export class DescendantPanel extends React.PureComponent<Props, State> {
    public render() {
        const { showContent, label, callAmount, panelData, maximizePanel, togglePanel, showPlusWhenPositive, onSelectFunction } = this.props

        return (
            <div>
                <DescendantPanelTrigger label={label} callAmount={callAmount} maximizePanel={maximizePanel} togglePanel={togglePanel} />
                {showContent && (
                    <div className="call-descendants" style={{ height: maximizePanel.isActive ? '40vh' : '16vh' }}>
                        <CallTable
                            select={onSelectFunction}
                            title={null}
                            calls={panelData}
                            showToggle={false}
                            compareMode={showPlusWhenPositive}
                        />
                    </div>
                )}
            </div>
        )
    }
}

interface DescendantPanelTriggerProps {
    label: string
    callAmount: string
    maximizePanel: {
        isActive: boolean
        handler: () => void
    }
    togglePanel: {
        isActive: boolean
        handler: () => void
    }
}

class DescendantPanelTrigger extends React.PureComponent<DescendantPanelTriggerProps> {
    public render(): React.ReactNode {
        const { label, callAmount, maximizePanel, togglePanel } = this.props

        const cnInverseIcon = isActive => (isActive ? 'fa-inverse' : '')
        const cnInverseBg = isActive => (!isActive ? 'fa-inverse' : '')

        const onMaximizePanel = (event: React.MouseEvent<HTMLDivElement>) => {
            event.stopPropagation()
            maximizePanel.handler()
        }

        return (
            <BoxHeader className="tw-p-0">
                <button
                    className="btn btn-flat btn-default tw-font-size-16 btn-group-justified"
                    style={{ textAlign: 'left' }}
                    onClick={() => togglePanel.handler()}
                >
                    <b>{`${label} (${callAmount})`}</b>
                    <div
                        className="text-mute tw-mr-4 tw-font-size-12 maximize"
                        onClick={event => onMaximizePanel(event)}
                        style={{ float: 'right', paddingTop: '5px' }}
                    >
                        <span className="fa fa-stack">
                            <i className={`fa fa-square fa-stack-2x ${cnInverseBg(maximizePanel.isActive)}`}></i>
                            <i
                                title={'restore list of ' + label}
                                className={`fa fa-window-maximize fa-stack-1x ${cnInverseIcon(maximizePanel.isActive)}`}
                            />
                        </span>
                    </div>
                    <span className="text-mute tw-mr-4 tw-font-size-12" style={{ float: 'right', paddingTop: '5px' }}>
                        <span className="fa fa-stack">
                            <i className={`fa fa-square fa-stack-2x ${cnInverseBg(togglePanel.isActive)}`}></i>
                            <i
                                title={'Minimize list of ' + label}
                                className={`fa fa-window-restore fa-stack-1x ${cnInverseIcon(togglePanel.isActive)}`}
                            />
                        </span>
                    </span>
                </button>
            </BoxHeader>
        )
    }
}
